import React, { type RefObject } from "react"

export const ScrollContext = React.createContext<RefObject<HTMLElement>>({
  current: null,
})
